// extracted by mini-css-extract-plugin
export default {"wrapper":"Landing_wrapper__P7Ftk","container":"Landing_container__PY2Fp","title":"Landing_title__lYcCu","subtitle":"Landing_subtitle__yr7rg"};